import packageData from './../../package.json'
import Exposure from '@/utils/exposure'
import Vue from 'vue'
import { isInCoinsApp, getQuery } from '@/utils/utils'
import { getNetInfo } from '@/utils/network'
import { globalVariable } from '@/utils/exportVariable'
import { loginQuickSuccessFB } from '@/utils/fbTtTrack'
import { getVersion } from '@/utils/toplupeVersion'
import webAPM from '@/utils/webApm'

// ABTest的code
let abgroup = '999999'

function getPublicParams() {
  let { source, userInfo } = globalVariable.store.state
  source === '' ? (source = getQuery('source')) : null
  !source ? (source = 'ns') : null
  isInCoinsApp() ? (source = 'inapp') : null
  const { valid, kicoinId } = userInfo || {}
  return {
    source,
    id: userInfo && valid ? kicoinId : 'none', // ki币id
    version: packageData.version,
    network: getNetInfo(), // wifi, 2g, 3g, 4g, 5g, offline
    abgroup,
    homev: getVersion(), // Toplupe版本
  }
}

// 上报yandex打点事件
export function track_yandex(eventName, params) {
  // 目前只上报 begin_checkou、purchase这两个事件
  // 在yandex管理后台需要为每个事件创建一个goal
  const goals = ['begin_checkout', 'purchase']

  if (
    window.ym &&
    typeof window.ym === 'function' &&
    goals.includes(eventName)
  ) {
    ym(88422897, 'reachGoal', eventName, params)
  }
}

/**
 *
 * @param {*} eventName 事件名
 * @param {*} params
 *  {
 *    page: pageName
 *  }
 */
export async function track_ga(eventName, params = {}) {
  if (!process.client) return

  if (!window.__trackQueue) {
    window.__trackQueue = []
  }

  const args = {
    ...getPublicParams(),
    ...params,
  }

  track_yandex(eventName, args)

  window.onload = async function () {
    if (window.gtag && typeof window.gtag === 'function') {
      window.__winload = true
      abgroup = '999999' //await initAbtest()
      args.abgroup = abgroup
      if (globalVariable && globalVariable.store) {
        globalVariable.store.commit('setABtestcode', abgroup)
      }

      gtag('event', eventName, args)
    }
  }

  if (window.__winload) {
    window.gtag && gtag('event', eventName, args)
    return
  }

  window.__trackQueue.push({
    eventName,
    params: args,
  })
}

export async function trackSuccessfulPurchase(params = {}) {
  track_ga('purchase', params)
}

// 页面曝光
export function show(params = {}) {
  track_ga('show', params)
}

// 任意点击
export function anyClick(params = {}) {
  if (!process.client) return
  function pageClick() {
    track_ga('any_click', params)
    window.removeEventListener('click', pageClick)
  }
  window.addEventListener('click', pageClick, false)
}
// 曝光
function exposureEvent(targets, callback) {
  const exposure = new Exposure()
  exposure.observer({
    threshold: 0.5, //交叉比例, 默认为1
    exposureType: 'once', // 曝光类型，反复曝光repeat / 单次曝光once, 默认单次曝光
    ele: targets, // 要监测的元素，可以是单个元素，也可以是nodelist
    callback: (ele) => {
      // 回调
      callback && callback(ele)
    },
  })
}

// 底部曝光
export async function bottomShow(params = {}, target = 'page-bottom') {
  await Vue.nextTick()

  const node = document.querySelector(`.${target}`)
  if (!node) {
    return
  }

  exposureEvent(node, function () {
    track_ga('bottom_show', params)
  })
}

// 返回首页
export function backHome(params = {}) {
  track_ga('back_home', params)
}

// 首页tab点击
export function homeTabClick(params = {}) {
  track_ga('home_tab_click', params)
}

// 订单tab点击
export function orderTabClick(params = {}) {
  track_ga('order_tab_click', params)
}

// 关于tab点击
export function aboutTabClick(params = {}) {
  track_ga('about_tab_click', params)
}

// 登录按钮曝光
export function loginShow(params = {}) {
  track_ga('login_show', params)
}

// 登录按钮点击
export function loginClick(params = {}) {
  track_ga('login_click', params)
}

// 快捷登录选择
// login_way: fb, gg, tt
export function loginQuick(params = {}) {
  track_ga('login_quick', params)
}

// 快捷登录成功
// login_way: fb, gg, tt
export function loginQuickSuccess(params = {}) {
  track_ga('login_quick_success', params)
  loginQuickSuccessFB(params)
}

// 切换国家
export function regionChange(params = {}) {
  track_ga('region_change', params)
}

// 点击协议
// type: privacy, user,service, legal
export function protocolPageview(params = {}) {
  track_ga('protocol_pageview', params)
}

// 反馈按钮点击
export function feedbackClick(params = {}) {
  track_ga('feedback_click', params)
}

// 点击消息中心
export function messageClick(params = {}) {
  track_ga('personal_message_click', params)
}

// 点击我的优惠券
export function couponClick(params = {}) {
  track_ga('personal_coupon_click', params)
}

// 订单反馈点击
export function feedbackOrderClick(params = {}) {
  track_ga('feedback_order_click', params)
}

// 产品反馈点击
export function feedbackProductClick(params = {}) {
  track_ga('feedback_product_click', params)
}

// 反馈页展示
// type: 反馈类型，order,product,contact_us
// from: 来源，contact_us, account,order_details
export function feedbackPageview(params = {}) {
  track_ga('feedback_pageview', params)
}

// 反馈提交成功
// type: 反馈类型，order,product,contact_us
// from: 来源，contact_us, account,order_details
export function feedbackSuccess(params = {}) {
  track_ga('feedback_success', params)
}

// 主动添加快捷方式
export function shortcutAdd(params = {}) {
  track_ga('shortcut_add', params)
}

// 添加快捷方式提示展现
export function shortcutPopup(params = {}) {
  track_ga('shortcut_popup', params)
}

// 同意添加点击
export function shortcutApprove(params = {}) {
  track_ga('shortcut_approve', params)
}

// 拒绝添加点击
export function shortcutCancel(params = {}) {
  track_ga('shortcut_cancel', params)
}

// 媒体分享按钮的曝光
export function shareShow(params = {}, target, type) {
  if (!type) {
    const node = document.querySelector(`.${target}`)
    if (!node) {
      return
    }
    exposureEvent(node, function () {
      track_ga('share_show', params)
    })
  } else {
    track_ga('share_show', params)
  }
}

// 媒体分享按钮的点击
export function shareClick(params = {}) {
  track_ga('share_click', params)
}

// 媒体分享成功弹出
export function shareSuccess(params = {}) {
  track_ga('share_success', params)
}

// 去facebook主页按钮
export function facebookHome(params = {}) {
  track_ga('facebook_home', params)
}

// 隐私政策点击
export function privacyClick(params = {}) {
  track_ga('privacy_click', params)
}

// FAQ点击
export function faqClick(params = {}) {
  track_ga('faq_click', params)
}

// FAQ问题点击
export function faqQuestionClick(params = {}) {
  track_ga('faq_question_click', params)
}

// FAQ问题答案点击
export function faqAnswerClick(params = {}) {
  track_ga('faq_answer_click', params)
}

// 点击右上角头像
export function accountClick(params = {}) {
  track_ga('personal_click', params)
}

// 账号信息点击
export function accountDetailsClick(params = {}) {
  track_ga('personal_account_click', params)
}

// 跳转订单页
export function accountOrderClick(params = {}) {
  track_ga('personal_order_click', params)
}

// 首页/详情页 - 优惠券活动弹窗曝光
export async function couponPopupShow(params = {}) {
  track_ga('coupon_popup_show', params)
}

// 首页/详情页 - 优惠券活动弹窗按钮点击
export function couponPopupClick(params = {}) {
  track_ga('coupon_popup_click', params)
}

// 展示详情页 banner 时
export function pageBannerShow(params = {}) {
  track_ga('page_banner_show', params)
}

// 点击详情页 banner时
export function pageBannerClick(params = {}) {
  track_ga('page_banner_click', params)
}

export const mounted_track = async (
  params,
  targetClassName,
  shareClassName
) => {
  anyClick(params)
  show(params)
  bottomShow(params, targetClassName)
  shareShow(params, shareClassName)

  const timeid = setTimeout(() => {
    const times = webAPM.getResult()
    const { page = {}, js = [], img = [], css = [], ajax = [] } = times || {}
    // page
    track_ga('timing_complete', {
      ...params,
      ...page,
      time_type: 'page',
    })
    // js
    trackResourceTime(js, params)
    // img
    trackResourceTime(img, params)
    // css
    trackResourceTime(css, params)
    // ajax
    trackResourceTime(ajax, params)

    clearTimeout(timeid)
  }, 3000)
}

function trackResourceTime(datas, params) {
  datas &&
    datas.forEach((item) => {
      const { host } = new URL(item.name)
      if (host.indexOf('.toplupe.') > -1) {
        track_ga('timing_complete', {
          ...params,
          time_type: 'resource',
          initiatorType: item.initiatorType,
          name: item.name,
          duration: item.duration,
        })
      }
    })
}

// 分享链接被打开
export const fission_share_success = ({ share_name }) => {
  track_ga('fission_share_success', { share_name })
}

// 30min没有操作自动刷新
export const auto_refresh_30min = () => {
  track_ga('auto_refresh_30min')
}

//发版时间和当前时间大于7天自动刷新
export const auto_refresh_7d = () => {
  track_ga('auto_refresh_7d')
}

//小米账号登录弹窗曝光
export const mi_login_show = () => {
  track_ga('mi_login_show')
}

//小米账号登录弹窗选择
export const mi_login_click = (params = {}) => {
  track_ga('mi_login_click', params)
}

//小米账号登录结果
export const mi_login_result = (params = {}) => {
  track_ga('mi_login_result', params)
}

//[whatsapp绑定页面] 验证码获取点击
export const whatsapp_getcode = (params = {}) => {
  track_ga('whatsapp_getcode', params)
}

//[whatsapp绑定页面] 点击绑定按钮
export const whatsapp_bind = (params = {}) => {
  track_ga('whatsapp_bind', params)
}

//[whatsapp绑定页面] whatsapp绑定点击
export const personal_whatsapp = (params = {}) => {
  track_ga('personal_whatsapp', params)
}

//[客户端引流] 点击banner触发
export const clientDownloadClick = (params = {}) => {
  track_ga('download_click', params)
}
